export const MIN_DEPOSIT_TO_PROPERTY_PRICE_RATIO = 0.15;
export const MAX_DEPOSIT_TO_PROPERTY_PRICE_RATIO = 0.85;
